module.exports = __webpack_public_path__ + "static/media/CACAO_05.26e02c21.png";